const FLAGS = {
  chatWidget: 'DISCO-396-chat-widget',
  unreadMessagesIcon: 'ACT-1688',
  zendeskAuthenticatedMessaging: 'RET-2711-zendesk-authenticated-messaging',
  zendeskChannelKey: 'RET-3303-zendesk-channel-key',
};

export default FLAGS;
